import React, { useEffect }  from 'react';
import styled from 'styled-components';
import { IconCalling } from '../../Assets/contacts/IconCalling';
import { Dictionery } from '../../Data/Dictionery';
import { IconSMS } from '../../Assets/contacts/IconSMS';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconInstagram } from '../../Assets/contacts/IconInstagram';
import { IconFacebook } from '../../Assets/contacts/IconFacebook';
import { IconYoutube } from '../../Assets/contacts/IconYoutube';
import { IconPhone } from '../../Assets/contacts/IconPhone';
import TourDetailsDatesCart from '../Carts/TourDetailsDatesCart';
import TourDetailsFacilityCart from '../Carts/TourDetailsFacilityCart';
import TourDetailsHotelsCart from '../Carts/TourDetailsHotelsCart';
import { IconLocation } from '../../Assets/contacts/IconLocation';
import { IconAgency } from '../../Assets/contacts/IconAgency';
import { setMetaTags } from '../Functions/SetHeaders';
import { Link } from 'react-router-dom';
import { IconRouting } from '../../Assets/panels/IconRouting';
const Styles = styled.div`
  margin: 0 0 0.5rem;
  .back-drop {
    width: 100%;
    height: 30vh;
    height: 30lvh;
    overflow: hidden;
    border-radius:0 0 var(--border-radius-3) var(--border-radius-3);
    position: relative;
    isolation: isolate;
    background-color: var(--prime-1);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: blur(10px);
    }
    &::after{
      z-index: 2;
      content: " ";
      position: absolute;
      inset: 0;
      background-color: #00000030;
    }
    margin-bottom: -10vh;
    margin-bottom: -10lvh;
  }
  .over-tour {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 0 var(--universal-pad) 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    .base {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .desc {
        text-decoration: none;
        color: inherit;
        display: flex;
        gap: 0.5rem;
        align-items: center;
        font-size: 0.9rem;
        font-weight: 600;
        .desc-link {
          color: var(--c-main);
        }
        svg {
          fill: var(--n-grey-2);
          width: 32px;
          height: 32px;
          display: block;
        }
      }
    }
    .image {
      width: 30%;
      max-width: 300px;
      aspect-ratio: 1.8;
      border: 1px solid var(--n-grey-1);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      background-color: var(--n-grey-01);
      .icon-def {
        position: absolute;
        top: calc(50% - 24px);
        right: calc(50% - 24px);
        display: block;
        fill: var(--n-grey-2);
        z-index: 1;
      }
      img {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  .box-details {
    width: calc(100% - calc(calc(var(--universal-pad) - 1rem) * 2) );
    margin: 0 calc(var(--universal-pad) - 1rem) 1rem;
  }
  @media screen and (max-width: 850px) {
        .over-tour {
            padding: 1rem;
            flex-direction: column;
            align-items: normal;
            gap: 1rem;
            .image {
                width: 100%;
                max-width: none;
                aspect-ratio: 2.5;
            }
            .expand {
                display: none;
            }
        }
    }
`
export default function TourMain16 (props){
  const {data: dataRaw, lan, tour} = props;
  const data = JSON.parse(dataRaw);
  console.log(lan)
  useEffect(() => {
    setMetaTags("Luxintrip", "", "noindex");
  }, []);
  useEffect(() => {
    setMetaTags("Luxintrip", "", "noindex");
  }, [tour]);
  return (
    <Styles>
      <div className='back-drop'>
        {
            (tour.Tour_Image) ? (
                <img src={tour.Tour_Image} alt={"background"} onError={(e) => e.target.style.opacity = 0}/>
            ) : ""
        }
      </div>
      <div className='over-tour'>
        <div className='image'>
          <IconRouting className={"icon-def"}/>
          {
              (tour.Tour_Image) ? (
                  <img src={tour.Tour_Image} alt={tour.Tour_Name} onError={(e) => e.target.style.opacity = 0}/>
              ) : ""
          }
        </div>
        <div className='base'>
          <h1 className='title1'>
            {tour.Tour_Name}
          </h1>
          <div className='desc'>
            <IconBuilding/>
            {tour.Tour_Desc}
          </div>
          {
            (tour.City_Name && tour.Country_Name) ? (
              <>
              <div className='desc'>
                <IconLocation/>
                {tour.Country_Name} - {tour.City_Name}
              </div>
              </>
            ) : ""
          }
          {
            (tour.Agency_Name) ? (
              <>
              <Link to={"/" + lan.filename + "/travel-agency/" + tour.Agency_Origin_Id} className='desc'>
                <IconAgency/>
                {Dictionery.organizer[lan.filename]}: {tour.Agency_Name} <span className='desc-link'>{"("}{Dictionery.moreAgency[lan.filename]}{")"}</span>
              </Link>
              </>
            ) : ""
          }
        </div>
        <div className='end'>
          
        </div>
      </div>
      <div className='box-details'>
        {
          (tour.Tour_Type_Id === 1) ? (
            <TourDetailsDatesCart data={tour} lang={lan.filename} loading={false}/>
          ) : ""
        }
        <TourDetailsFacilityCart data={tour} lang={lan.filename} loading={false}/>
        {
          (tour.Tour_Type_Id === 1) ? (
            <TourDetailsHotelsCart data={tour} lang={lan.filename} loading={false}/>
          ) : ""
        }
      </div>
    </Styles>
  )
}

